import { Navigate, Routes, Route } from "react-router-dom";
import HomePage from "./pages/home";
import AuthConfirmPage from "./pages/authConfirm";
import LoginPage from "./pages/login";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import PATHS from "./constants/paths";
import ViveroFormPage from "./pages/vivero/form";
import ViveroListPage from "./pages/vivero/list";
import VarietyFormPage from "./pages/variety/form";
import VarietyListPage from "./pages/variety/list";
import BatchFormPage from "./pages/batch/form";
import BatchListPage from "./pages/batch/list";
import TaskFormPage from "./pages/task/form";
import TaskListPage from "./pages/task/list";
import ArticleFormPage from "./pages/article/form";
import ArticleListPage from "./pages/article/list";
import LocationFormPage from "./pages/location/form";
import LocationListPage from "./pages/location/list";
import SectorFormPage from "./pages/sector/form";
import SectorListPage from "./pages/sector/list";
import CodeFormPage from "./pages/code/form";
import CodeListPage from "./pages/code/list";
import WorkingPartFormPage from "./pages/workingPart/form";
import WorkingPartListPage from "./pages/workingPart/list";
import WorkingPartAllListPage from "./pages/workingPart/unbundled/list";
import WorkingPartListTechnicalPage from "./pages/workingPart/technicalList";
import WorkingPartDetailPage from "./pages/workingPart/detail";
import WorkingPartDetailTechPage from "./pages/workingPart/detailTech";
import UserListPage from "./pages/users/list";
import MermaPartListPage from "./pages/mermaPart/list";
import ReportsPage from "./pages/reports";

/* GENERATOR_INJECT_IMPORT_PAGE */

function App() {
  // const navigate = useNavigate();
  // const { user } = AuthContainer.useContainer();

  return (
    <Routes>
      {/* <Route path="/logout" element={<Logout />} /> */}
      <Route path="/technical" element={<ProtectedRoutes />}>
        <Route
          exact
          path={PATHS.MY_WORKING_PART_LIST}
          element={<WorkingPartListTechnicalPage />}
        />
        <Route
          exact
          path={PATHS.TEC_CREATE_WORKING_PART}
          element={<WorkingPartFormPage />}
        />
        <Route
          exact
          path={PATHS.TEC_DETAIL_WORKING_PART}
          element={<WorkingPartDetailTechPage />}
        />
      </Route>

      <Route path="/user" element={<ProtectedRoutes />}>
        <Route path={PATHS.REPORTS} exact element={<ReportsPage />} />
        <Route path={PATHS.USERS} exact element={<UserListPage />} />
        <Route path={PATHS.VIVERO_LIST} exact element={<ViveroListPage />} />
        <Route path={PATHS.VARIETY_LIST} exact element={<VarietyListPage />} />
        <Route path={PATHS.BATCH_LIST} exact element={<BatchListPage />} />
        <Route path={PATHS.TASK_LIST} exact element={<TaskListPage />} />
        <Route path={PATHS.ARTICLE_LIST} exact element={<ArticleListPage />} />
        <Route
          path={PATHS.LOCATION_LIST}
          exact
          element={<LocationListPage />}
        />
        <Route path={PATHS.SECTOR_LIST} exact element={<SectorListPage />} />
        <Route path={PATHS.CODE_LIST} exact element={<CodeListPage />} />
        <Route
          path={PATHS.WORKING_PART_LIST}
          exact
          element={<WorkingPartListPage />}
        />
        <Route
          path={PATHS.ALL_WORKING_PART_LIST}
          exact
          element={<WorkingPartAllListPage />}
        />
        <Route
          path={PATHS.MERMA_PART_LIST}
          exact
          element={<MermaPartListPage />}
        />
        <Route
          exact
          path={PATHS.DETAIL_WORKING_PART}
          element={<WorkingPartDetailPage />}
        />
        {/* GENERATOR_INJECT_LIST_ROUTE */}
        <Route exact path={PATHS.CREATE_VIVERO} element={<ViveroFormPage />} />
        <Route exact path={PATHS.UPDATE_VIVERO} element={<ViveroFormPage />} />

        <Route
          exact
          path={PATHS.CREATE_VARIETY}
          element={<VarietyFormPage />}
        />
        <Route
          exact
          path={PATHS.UPDATE_VARIETY}
          element={<VarietyFormPage />}
        />

        <Route exact path={PATHS.CREATE_BATCH} element={<BatchFormPage />} />
        <Route exact path={PATHS.UPDATE_BATCH} element={<BatchFormPage />} />

        <Route exact path={PATHS.CREATE_TASK} element={<TaskFormPage />} />
        <Route exact path={PATHS.UPDATE_TASK} element={<TaskFormPage />} />

        <Route
          exact
          path={PATHS.CREATE_ARTICLE}
          element={<ArticleFormPage />}
        />
        <Route
          exact
          path={PATHS.UPDATE_ARTICLE}
          element={<ArticleFormPage />}
        />

        <Route
          exact
          path={PATHS.CREATE_LOCATION}
          element={<LocationFormPage />}
        />
        <Route
          exact
          path={PATHS.UPDATE_LOCATION}
          element={<LocationFormPage />}
        />

        <Route exact path={PATHS.CREATE_SECTOR} element={<SectorFormPage />} />
        <Route exact path={PATHS.UPDATE_SECTOR} element={<SectorFormPage />} />

        <Route exact path={PATHS.CREATE_CODE} element={<CodeFormPage />} />
        <Route exact path={PATHS.UPDATE_CODE} element={<CodeFormPage />} />

        <Route
          exact
          path={PATHS.CREATE_WORKING_PART}
          element={<WorkingPartFormPage />}
        />
        <Route
          exact
          path={PATHS.UPDATE_WORKING_PART}
          element={<WorkingPartFormPage />}
        />

        {/* GENERATOR_INJECT_FORM_ROUTE */}
        <Route path={PATHS.HOME} exact element={<HomePage />} />
      </Route>

      <Route
        path={PATHS.EXTERNAL_CONFIRM_LOGIN}
        exact
        element={<AuthConfirmPage />}
      />
      <Route path="/login" exact element={<LoginPage />} />
      <Route path="/" element={<Navigate to={"/login"} />} />
    </Routes>
  );
}

export default App;
